module.exports = __webpack_public_path__ + "static/img/位图备份.21faabf1.png";